export default __webpack_public_path__ + "static/media/fcl.2ac3932e.svg";